import { ref } from 'vue';

const visibleProperties = ref([]);

const addNewVisibleProperties = (properties) => {
  visibleProperties.value = properties;
};

const clearNewVisibleProperties = () => {
  visibleProperties.value = [];
};

export default function useCustomCompsetState() {
  return {
    visibleProperties,
    addNewVisibleProperties,
    clearNewVisibleProperties,
  };
}
